import showForTimeTrackingEnabled from '../hoc/showForTimeTrackingEnabled';
import BarberListHeaderColumn from '../components/BarberListHeaderColumn';

const BarberListHeaderColumnContainer = showForTimeTrackingEnabled(BarberListHeaderColumn);

export default BarberListHeaderColumnContainer;
